module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-BdCn.8f33d923.otf";